import React from "react";
import { storyblokEditable, renderRichText } from "@storyblok/react";
import HeroImage from "@/library/components/images/HeroImage";
import RichTextBlock from "@/storyblok/block-library/rich-texts/RichTextBlock";
import StoryBlokLink from "@/storyblok/utils/links/StoryBlokLink";
import { cn } from "@/storyblok/utils/cn";
import Title from "../texts/Title";

export default function HeroWImage(props) {
  const {
    blok = {},
    title = "",
    titleAs = "h1",
    titleColor = "text-textWhite",
    content = "",
    contentColor = "text-textWhite",
    images = {},
    hasButtons = true,
  } = props;

  const hasImages = images.length > 0;

  const contentClasses = cn({
    "text-textPrimary": contentColor === "textPrimary",
    "text-textSecondary": contentColor === "textSecondary",
    "text-textBlack": contentColor === "textBlack",
    "text-textLight": contentColor === "textLight",
    "text-textWhite": contentColor === "textWhite",
    "text-textGrey": contentColor === "textGrey",
    "text-textOrange": contentColor === "textOrange",
  });

  const layoutClasses = cn(
    "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col",
    {
      "md:pr-0 md:flex-row items-center pt-0 md:pt-12 pb-12 gap-8":
        hasImages === true,
      "flex-col-2 flex-row p-12": hasImages === false,
    }
  );

  return (
    <section
      className="bg-secondary-accent text-textWhite"
      {...storyblokEditable(blok)}
    >
      <div className={`${layoutClasses}`}>
        <div className="block md:hidden w-screen">
          {images.length > 0 && <HeroImage images={images} />}
        </div>

        <div className="flex-1 md:text-left">
          <Title
            title={title}
            titleColor={titleColor}
            titleAs={titleAs}
            className={"mb-4"}
          />
          <RichTextBlock content={content} className={contentClasses} />
          <div className="mt-8 flex flex-wrap gap-2">
            {blok.buttons?.map((buttonBlok) => (
              <StoryBlokLink
                key={buttonBlok._uid}
                link={buttonBlok.buttonLink}
                buttonText={buttonBlok.buttonText}
                buttonType={buttonBlok.buttonType || "glowingOrange"}
                size={buttonBlok.size}
              />
            ))}
          </div>
        </div>

        <div className="hidden md:block self-center flex-1 relative angle-left">
          {images.length > 0 && <HeroImage images={images} />}
        </div>
      </div>
    </section>
  );
}
